import { Link } from '@tanstack/react-router';
import { cn } from '@/shared/lib/cn';

interface Props {
  quarantined: number;
  awaiting: number;
  /** Nachladen schlug fehl: die Zahlen sind ein älterer Stand. */
  stale?: boolean;
  className?: string;
}

/**
 * Hinweis über der Buchungsliste (Board „Buchungen“): nicht übernommene Kanalbuchungen fehlen in der
 * Liste – in der Quarantäne braucht eine jemanden, eine wartende versucht der Server selbst. Ohne
 * beides erscheint nichts.
 */
export function QuarantineHint({ quarantined, awaiting, stale = false, className }: Props) {
  if (quarantined <= 0 && awaiting <= 0) return null;
  const parts = [
    quarantined > 0 ? `${quarantined} in Quarantäne` : null,
    awaiting > 0 ? `${awaiting} ${awaiting === 1 ? 'wartet' : 'warten'} auf die Zuordnung` : null,
  ].filter(Boolean);
  return (
    <Link
      to="/bookings/quarantine"
      aria-label={`Nicht übernommene Kanalbuchungen ansehen: ${parts.join(', ')}`}
      className={cn(
        'rounded-tile text-ink flex flex-wrap items-center gap-3.5 border px-4 py-3.5 no-underline',
        quarantined > 0 ? 'bg-amber-wash border-amber-tint' : 'border-hairline bg-white',
        className,
      )}
    >
      <span className="bg-amber-tint rounded-control flex size-11 flex-none items-center justify-center font-serif text-[22px] font-bold">
        {quarantined + awaiting}
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        <b className="text-[15px]">Kanalbuchungen nicht übernommen</b>
        <span className="text-ink-soft text-[13px]">
          {parts.join(' · ')} – bis dahin fehlen sie hier oder stehen noch im alten Stand.
          {stale ? ' Älterer Stand – Aktualisieren schlug fehl.' : ''}
        </span>
      </span>
      <span className="bg-ink rounded-pill flex h-[42px] items-center px-4 text-[13px] font-bold text-white">
        Ansehen
      </span>
    </Link>
  );
}
